export default __webpack_public_path__ + "static/media/diff-and-common-example.f8bee485.svg";